import React from 'react'
import { trackECommerceEvent } from '~/tools/analytics/googleAnalytics'
import Spinner from '~/components/Spinner'
import getQueryVariable from '~/tools/getQueryVariable'

import './style.css'

class Notice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount(){
    this.interval = setInterval(() => this.refresh(), 500)
  }

  refresh(){
    if(window.dataLayer){
      clearInterval(this.interval)
      this.setState({loading: false})
      this.sendEvents()
    }
  }

  sendEvents(){
    const title = decodeURIComponent(getQueryVariable('title'))
    if (title.includes('Thank')) {
      const ga = window.ga;
      console.log(window.dataLayer)
      const dataLayer = window.dataLayer || { push: _ => { } }
      const subscriptionInfo = JSON.parse(localStorage.getItem('planDetails'))
      const userInfo = JSON.parse(localStorage.getItem('user'))
      ga("ec:setAction", "checkout", { 'step': 3 })
      trackECommerceEvent('ec:addProduct', {
        id: subscriptionInfo.id,
        name: subscriptionInfo.name,
        price: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        quantity: 1
      })
      ga("send", "event", "e-commerce", "checkout", "3")
      ga("ec:setAction", "purchase", {
        revenue: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        id: `${userInfo.user.userId} - ${Date.now()}`
      })
      trackECommerceEvent('ec:addProduct', {
        id: subscriptionInfo.id,
        name: subscriptionInfo.name,
        price: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        quantity: 1
      })
      ga('set', 'currencyCode', subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode)
      ga('send', 'event', 'e-commerce', 'purchase')
      dataLayer.push({
        "event": "finish_subscription",
        "plan_currency_code": subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode,
        "plan_uuid": subscriptionInfo.id,
        "plan_name": subscriptionInfo.name,
        "plan_price": subscriptionInfo.planDetails[0].recurringPaymentAmount,
        "transaction_id": `${userInfo.user.userId} - ${Date.now()}`
      })
    }
  }

  render() {
    var title = decodeURIComponent(getQueryVariable('title'))
    var message = decodeURIComponent(getQueryVariable('message'))

    return (
      <div className="notice-popup centered padded">
        {this.state.loading ? <div className="loading centered">
          <div className="loading-message"> Please don't close or refresh the page. Subscription is in progress </div> 
            <Spinner />
          </div> :
          <div>
            <div className="title">{ title }</div>
            <div className="message">{ message }</div>
          </div>
        }
      </div>
    )
  }
}

export default Notice;
